/* ==========================================================================
   Medical Mart — cart drawer fix
   Added 24 August 2026

   Fixes three defects in theme.min.js -> theme.ajaxCart():

   1. On a successful add, the drawer opened only after a 1000ms setTimeout,
      behind a full-screen "loading" overlay.
   2. The same success handler set:
          drawerTimeout = setTimeout(function(){
            $(".block-cart").removeClass("active");
          }, 7000);
      i.e. the cart drawer CLOSED ITSELF 7 seconds after opening, while the
      customer was still reading it.
   3. addinToCart() calls CartJS.addItem() with no existence check. vendor.js
      (which provides CartJS) is loaded with defer, so a tap before it finishes
      throws a ReferenceError and the click is silently dropped — no drawer,
      no error, nothing.

   This file is purely additive. It does not modify theme.min.js.
   To revert: delete this file and remove its <script> tag from
   snippets/azexo-footer-scripts.liquid.
   ========================================================================== */

(function () {
  if (!window.jQuery) return;
  var $ = window.jQuery;
  var DRAWER = '.block-cart';

  function cancelAutoClose() {
    /* the theme leaves drawerTimeout as an implicit global (never declared),
       so it is reachable here and can be cleared */
    if (window.drawerTimeout) {
      clearTimeout(window.drawerTimeout);
      window.drawerTimeout = null;
    }
  }

  function openDrawer() {
    $('body').removeClass('loading showOverly');
    $(DRAWER).addClass('active');
    cancelAutoClose();
  }

  /* ---- FIX 3 ------------------------------------------------------------
     Runs in the CAPTURE phase, so it fires before the theme's own delegated
     handler. If CartJS has not loaded yet, let the form post natively rather
     than dropping the customer's tap on the floor. They land on /cart with
     the item in it — not ideal, but never silent.                          */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest &&
              e.target.closest('.product-form__cart-submit');
    if (!btn) return;
    if (typeof window.CartJS !== 'undefined') return;
    if (btn.getAttribute('disabled') === 'disabled') return;

    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    form.submit();
  }, true);

  /* ---- FIX 1 (part a) ---------------------------------------------------
     Immediate acknowledgement on tap, before any network call. On mobile the
     header cart badge is off-screen, so without this the page appears not to
     respond at all.                                                        */
  $(document).on('click touchend', '.product-form__cart-submit, .add-to-cart', function () {
    var $btn = $(this);
    if ($btn.data('mmBusy')) return;
    if ($btn.attr('disabled') === 'disabled') return;

    $btn.data('mmBusy', 1).data('mmLabel', $btn.text());
    $btn.text('Adding…');

    /* safety: always restore the label even if nothing else fires */
    setTimeout(function () { restore($btn); }, 3000);
  });

  function restore($btn) {
    var label = $btn.data('mmLabel');
    if (label) $btn.text(label);
    $btn.removeData('mmBusy').removeData('mmLabel');
  }

  function restoreAll() {
    $('.product-form__cart-submit, .add-to-cart').each(function () {
      var $b = $(this);
      if ($b.data('mmBusy')) restore($b);
    });
  }

  /* ---- FIX 1 (part b) + FIX 2 -------------------------------------------
     CartJS fires cart.requestComplete as soon as the cart actually changes.
     Open the drawer straight away instead of waiting 1000ms, and keep
     clearing the theme's 7-second auto-close — it is set inside the theme's
     own success callback, which may run just after this one.               */
  $(document).on('cart.requestComplete', function () {
    restoreAll();
    openDrawer();
    [40, 150, 400, 1100, 1600].forEach(function (ms) {
      setTimeout(function () {
        cancelAutoClose();
        $(DRAWER).addClass('active');
      }, ms);
    });
  });

  /* The customer closes the drawer, not a timer. These are the theme's own
     close controls; leave them working exactly as before. */
  $(document).on('click', '.close-cart, .page-wrapper', function () {
    cancelAutoClose();
  });
})();
